<template lang="pug">
  .recommended-blog    
    span.featured-article.bold.upper.xs-f-xsmall.lg-f-small.max-at-tweak Featured article
    img.featured-image(:src="blogArticle.thumb_url" :alt="blogArticle.alt_text")
    p.article-description.xs-f-xsmall.lg-f-small.max-at-tweak {{ blogArticle.short_description }}
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';

  export default {
    name: "RecommendedBlog",

    props: {
      blogArticle: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped lang="stylus">
  .recommended-blog
    padding 1.5em 30%
    padding-top 0
    .featured-image
      width 11em
      text-align center
      display inline-block
      margin .5em
      
    .article-description
      display block
      padding 0
    .featured-article
      padding .5em
      padding-top 0
      display block

    @media mq-mobile
      padding 1.5em 5%
      padding-top 0
</style>